// @ts-ignore
/* eslint-disable */
import request from '../../utils/request';

/** 获取阿里云人脸识别认证结果 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /verify/ali-face/result */
export async function verifyAliFaceResultUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.verifyAliFaceResultUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultDescribeAliFaceResp>('/verify/ali-face/result', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取人脸识别策略选择 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /verify/face-channel */
export async function verifyFaceChannelUsingGET(options?: { [key: string]: any }) {
  return request<API.BaseResultstring>('/verify/face-channel', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 提交阿里云人脸识别认证 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 POST /verify/submit-ali-face */
export async function verifySubmitAliFaceUsingPOST(
  body: API.AliFaceVerifyReq,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultAliFaceAuthResp>('/verify/submit-ali-face', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}
